module.exports = __webpack_public_path__ + "img/topups.fc9a2c77.png";